import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { type Plugin } from "@nuxt/types";

// https://docs.datadoghq.com/real_user_monitoring/browser/modifying_data_and_context/?tab=npm#sampling
const sampleAll = 100;
const sampleLimitedProd = 1;

const plugin: Plugin = ({ $config, app }) => {
  const { env, version } = $config;
  const { clientToken, service, site } = $config.datadog;
  const { applicationId } = $config.datadog.rum;
  const sessionSampleRate = env === "prod" ? sampleLimitedProd : sampleAll;

  datadogRum.init({
    applicationId,
    clientToken,
    site,
    service,
    env,
    version,
    trackViewsManually: true,
    trackUserInteractions: true,
    trackFrustrations: true,
    trackResources: true,
    trackLongTasks: true,
    sessionSampleRate,
    sessionReplaySampleRate: sessionSampleRate,
    // Need to expand CORS config headers from tyk and other sources before enabling tracing origins
    // access-control-request-headers: authorization,x-datadog-origin,x-datadog-parent-id,x-datadog-sampled,x-datadog-sampling-priority,x-datadog-trace-id
    allowedTracingOrigins: [
      /https?:\/\/.*\.rewardstyle\.com/,
      /https?:\/\/.*\.liketoknow\.it/,
      /https?:\/\/(?!login\.).*\.shopltk\.com/,
      /https?:\/\/(?!login\.).*\.qashopltk\.com/,
    ],
  });

  datadogRum.startSessionReplayRecording();

  datadogLogs.init({
    clientToken,
    site,
    service,
    env,
    version,
    sessionSampleRate,
  });

  app.router?.afterEach((to) => {
    datadogRum.startView(to.meta?.viewName ?? to.name ?? to.path);
  });
};

export default plugin;
